import { render, staticRenderFns } from "./vcLoading.vue?vue&type=template&id=1d83ccf6&scoped=true&"
import script from "./vcLoading.vue?vue&type=script&lang=js&"
export * from "./vcLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d83ccf6",
  null
  
)

export default component.exports